import { jsx as _jsx } from "react/jsx-runtime";
import { Menu as MuiMenu } from '@mui/material';
import { forwardRef } from 'react';
export const Menu = forwardRef(function Menu({ children, ...props }, ref) {
    return (_jsx(MuiMenu, { ref: ref, ...props, children: children }));
});
